import React from 'react'
import RoomConfiguratorHeader from '../Header'
import FormPlaceholder from '../Form/Placeholder'
import { Placeholder as DSPlaceholder } from '@s4l/ds'

import styles from '../styles.module.css'

function Placeholder() {
  return (
    <div className={styles.container} data-testid="room-offers-list-loading">
      <RoomConfiguratorHeader>
        <DSPlaceholder height="200px" />
      </RoomConfiguratorHeader>
      <FormPlaceholder />
      <DSPlaceholder.Animation />
    </div>
  )
}

Placeholder.displayName = 'RoomConfigurator.Placeholder'
export default Placeholder
